import { useEffect } from "react";

export default function SmoothScroll() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    let lenis;
    let frameId;
    let cancelled = false;

    const boot = () => {
      import("lenis")
        .then(({ default: Lenis }) => {
          if (cancelled) return;
          lenis = new Lenis({
            duration: 1.05,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
          });
          const raf = (time) => {
            lenis.raf(time);
            frameId = requestAnimationFrame(raf);
          };
          frameId = requestAnimationFrame(raf);
        })
        .catch(() => {});
    };

    if ("requestIdleCallback" in window) {
      const idleId = window.requestIdleCallback(boot, { timeout: 2500 });
      return () => {
        cancelled = true;
        window.cancelIdleCallback(idleId);
        if (frameId) cancelAnimationFrame(frameId);
        lenis?.destroy();
      };
    }

    const timeoutId = window.setTimeout(boot, 1200);
    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
      if (frameId) cancelAnimationFrame(frameId);
      lenis?.destroy();
    };
  }, []);

  return null;
}
